<template>
  <div class="content-card">
    <div class="content-title">
      个人信息
      <el-button
          type="primary"
          size="small"
          @click="isEditing = !isEditing"
          class="edit-btn"
      >
        {{ isEditing ? '取消' : '编辑' }}
      </el-button>
    </div>
    <el-card class="info-card" v-if="isEditing">
      <el-form
          :model="editForm"
          :rules="editRules"
          ref="editFormRef"
          label-width="12rem"
          class="edit-form"
      >
        <el-form-item label="用户名" prop="loginName">
          <el-input v-model="editForm.loginName" disabled :style="{width: '40rem'}" style="font-size: 2em"></el-input>
        </el-form-item>
        <el-form-item label="昵称" prop="name">
          <el-input v-model="editForm.name" :style="{width: '40rem'}" style="font-size: 2em"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="editForm.email" type="email" :style="{width: '40rem'}" style="font-size: 2em"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="editForm.phone" :style="{width: '40rem'}" style="font-size: 2em"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              @click="handleSave"
              class="save-btn"
              style="font-size: 1.6rem"
          >
            保存
          </el-button>
          <el-button
              @click="handleCancel"
              class="cancel-btn"
              style="font-size: 1.6rem"
          >
            取消
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="info-card" v-else>
      <el-descriptions
          title="基本信息"
          border
          column="2"
          :size="'large'"
      >
        <el-descriptions-item label="用户名">
          <span class="info-value">{{ userInfo.loginName }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="昵称">
          <span class="info-value">{{ userInfo.name }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="邮箱">
          <span class="info-value">{{ userInfo.email }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="手机号">
          <span class="info-value">{{ userInfo.phone }}</span>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import newService from "@/api/newService";

export default {
  name: "UserInfo",
  props: {
    userInfo: {
      type: Object,
      default: () => ({
        loginName: "",
        name: "",
        email: "",
        phone: ""
      })
    }
  },
  data() {
    // 修改邮箱验证规则
    const validateEmail = (rule, value, callback) => {
      // 新增：如果为空则直接通过
      if (!value) {
        callback();
        return;
      }
      // 原有格式校验逻辑保留
      const reg = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入有效的邮箱地址"));
      } else {
        callback();
      }
    };

    // 修改手机号验证规则
    const validatePhone = (rule, value, callback) => {
      // 新增：如果为空则直接通过
      if (!value) {
        callback();
        return;
      }
      // 原有格式校验逻辑保留
      const reg = /^1[3-9]\d{9}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入有效的手机号"));
      } else {
        callback();
      }
    };

    return {
      isEditing: false, // 编辑状态控制
      editForm: { ...this.userInfo }, // 编辑表单数据
      editRules: {
        name: [
          { required: true, message: "请输入昵称", trigger: "blur" },
          { min: 2, max: 10, message: "昵称长度需在2-10位之间", trigger: "blur" }
        ],
        email: [
          { validator: validateEmail, trigger: "blur" } // 移除required
        ],
        phone: [
          { validator: validatePhone, trigger: "blur" } // 移除required
        ]
      }
    };
  },
  watch: {
    userInfo: {
      handler(newVal) {
        this.editForm = { ...newVal };
      },
      deep: true
    }
  },
  methods: {
    // 保存
    handleSave() {
      this.$refs.editFormRef.validate((isValid) => {
        if (isValid) {
          // 发送更新用户信息事件给父组件
          this.$emit('updateUserInfo', this.editForm);

          let obj = { ...this.editForm, loginName: '' };
          newService.saveUser(obj).then(() => {
            var userinfo = this.$TOOL.data.get('USER_INFO');
            this.$TOOL.data.set('USER_INFO', {...userinfo, name: obj.name });
            this.$store.state.userName = obj.name;
                this.$message({ type: "success", message: "个人信息修改成功！" });
          }).catch(() => {
            this.$message({ type: "error", message: "个人信息修改失败！" });
          }).finally(() => {
            this.isEditing = false;
          });
        }
      });
    },
    // 取消
    handleCancel() {
      this.$refs.editFormRef.resetFields();
      this.isEditing = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.content-card {
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 0.5rem;
  box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.05);
  padding: 3rem;
  margin-bottom: 5rem;
}

.content-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 2.4rem;
  color: #333333;
  font-weight: 500;
  margin-bottom: 3rem;
  padding-bottom: 1rem;
  border-bottom: 0.1rem solid #E5E5E5;

  .edit-btn {
    font-size: 1.6rem;
    background-color: #FF0B41;
    border-color: #FF0B41;
  }
}

// 个人信息卡片样式
.info-card {
  border: none;
  box-shadow: none;

  ::v-deep .el-descriptions {
    font-size: 1.6rem;

    .el-descriptions-title {
      font-size: 2rem;
      color: #333333;
      margin-bottom: 2rem;
    }

    .el-descriptions-item {
      padding: 1.5rem 1rem;
      color: #444955;

      .el-descriptions-item__label {
        font-weight: 500;
        color: #333333;
      }
    }
  }

  .info-value {
    color: #444955;
    font-size: 1.6rem;
  }
}

.edit-form {
  padding-top: 2rem;

  ::v-deep .el-form-item {
    margin-bottom: 2.5rem;

    .el-form-item__label {
      font-size: 1.6rem;
      color: #333333;
    }

    .el-input {
      font-size: 1.6rem;

      ::v-deep .el-input__inner {
        height: 4rem;
        line-height: 4rem;
        border-radius: 0.3rem;
        border: 0.1rem solid #E5E5E5;

        &:focus {
          border-color: #FF0B41;
          box-shadow: 0 0 0 0.2rem rgba(255, 11, 65, 0.2);
        }
      }
    }
  }

  .form-hint {
    color: #999;
    font-size: 1.4rem;
    margin-top: 0.5rem;
  }

  .save-btn {
    background-color: #FF0B41;
    border-color: #FF0B41;
    margin-right: 1rem;
  }

  .cancel-btn {
    background-color: #fff;
    color: #333;
    border-color: #ddd;
  }
}
</style>
